import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SellerShellPfComponent } from './seller-shell-pf/seller-shell-pf.component';

const routes: Routes = [
  {
    path: 'seller-info-pf',
    component: SellerShellPfComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [Location],
  exports: [RouterModule],
})
export class SellerPfRoutingModule {}
